import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { ChatShort } from "../../../shared/models/Chat";

export interface GetChatProps {
  offset: number;
  limit: number;
  companyId?: number;
  query?: string;
  from?: Date;
  to?: Date;
}

export const useSearchChats = (userId?: string) => {
  const {
    data: chats,
    call,
    isLoading,
  } = useApiPrivateRequest<ChatShort[]>((response) =>
    response.map((chat: any) => new ChatShort(chat)),
  );

  const searchChats = async (props: GetChatProps) => {
    const result = await call(`${userId ? "/admin" : ""}/chats/search`, "GET", {
      userId,
      ...props,
    });

    if (!result) {
      return [];
    }

    const mappedChats = result.map((chat: any) => new ChatShort(chat));
    return mappedChats;
  };

  return { chats, searchChats, isLoading };
};
